/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class QuickPaymentApportioner extends Component {
  // Services
  @service
  store;

  lineItems = [];
  onApportion() {}

  @action
  apportion(item) {
    this.onApportion(item);
  }
}
